import { themeColors } from "@/styles"
import { makeStyles } from "@/utils/makeStyles"

const useStyles = makeStyles(() => ({
	card: {
		flex: 1,
		position: "relative",
		background: themeColors.colors.base.white,
		borderRadius: "0.5rem",
		transition: "all 225ms cubic-bezier(0.4, 0.6, 1)"
	},
	scrollBar: {
		"&::-webkit-scrollbar": {
			width: "0.375rem !important"
		},
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: themeColors.colors.system.gray[200]
		},
		"&::-webkit-scrollbar-track": {
			background: themeColors.colors.system.gray[900]
		}
	}
}))

export default useStyles